import React, { useCallback, useState, FC } from 'react';
import { useDropzone } from 'react-dropzone';
import Previeew from '../../assets/Preview.svg';
import { toast } from 'react-toastify';
import { getRandomID } from 'functions';
import Styles from './Styles.module.scss';
import { SVG } from 'Common/commonsvg';

interface DropZoneProps {
  setimage: (file: File) => void;
  DropZoneText?: string; // Corrected to lowercase 'string'
  previewimage: Boolean;
  Setimagebool?: (open: boolean) => void;
  classname?: String;
  onClick?: (file: any) => void;
  accept: 'pdf' | 'image' | 'csv' | 'excel' | 'none';
  previewposition?: 'top' | 'bottom' | 'inside' | 'original';
  image: string;
  max: boolean;
  dimensions: {
    height: number;
    width: number;
  };
  maxsize: number | 'null';
  disabled?: boolean; // ⬅️ Added
}

const DropZoneC: FC<DropZoneProps> = ({
  setimage,
  DropZoneText,
  previewimage = true,
  classname = '',
  onClick,
  previewposition = 'top',
  image,
  dimensions,
  max = true,
  Setimagebool,
  accept = 'none',
  maxsize = null,
  disabled = false,
}) => {
  const [Error, setError] = useState('');

  const checkDimensions = (file, dimensions, callback) => {
    const img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
      if (!max) {
        if (img.width >= dimensions.width && img.height >= dimensions.height) {
          callback(true);
        } else {
          toast.error(`Logo image should be ${dimensions.width}w x ${dimensions.height}h px size`);
          callback(false);
        }
      } else {
        if (img.width <= dimensions.width && img.height <= dimensions.height) {
          callback(true);
        } else {
          toast.error(`Logo image should be ${dimensions.width}w x ${dimensions.height}h px size`);
          callback(false);
        }
      }
    };
  };

  const checkFormat = (file: File) => {
    switch (accept) {
      case 'csv':
        if (file.type !== 'text/csv') {
          toast.error('Only CSV files are allowed');
          return false;
        }
        break;
      case 'excel':
        // Adjust this condition based on the Excel types you want to allow
        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          toast.error('Only Excel files are allowed');
          return false;
        }
        break;
      case 'pdf':
        if (file.type !== 'application/pdf') {
          toast.error('Only PDF files are allowed');
          return false;
        }
        break;
      case 'image':
        // Adjust this condition based on the image types you want to allow
        if (!file.type.startsWith('image/')) {
          toast.error('Only image files are allowed');
          return false;
        }
        break;
      default:
        // No specific format restriction for other cases
        break;
    }

    // If none of the above conditions triggered, or for the default case, return true
    return true;
  };
  function getAcceptForType(type) {
    switch (type) {
      case 'image':
        return {
          'image/png': ['.png'],
          'image/jpeg': ['.jpg', '.jpeg'],
          'image/webp': ['.webp'],
          'image/gif': ['.gif'],
          // 'image/tiff': ['.tif', '.tiff'],
        };
      case 'pdf':
        return {
          'application/pdf': ['.pdf'],
        };
      case 'excel':
        return {
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
          'application/vnd.ms-excel': ['.xls'],
        };
      case 'word':
        return {
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
          'application/msword': ['.doc'],
        };
      case 'text':
        return {
          'text/plain': ['.txt'],
        };
      case 'html':
        return {
          'text/html': ['.html', '.htm'],
        };
      case 'video':
        return {
          'video/mp4': ['.mp4'],
          'video/webm': ['.webm'],
          'video/ogg': ['.ogg'],
        };
      case 'audio':
        return {
          'audio/mpeg': ['.mp3'],
          'audio/wav': ['.wav'],
          'audio/ogg': ['.ogg'],
        };
      default:
        // Accept all
        return {};
    }
  }
  const [preview, setPreview] = useState<File[]>([]);
  const [previewname, setpreviewname] = useState<Array<String>>([]);
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    accept: getAcceptForType(accept),
    maxFiles: 1,
    disabled: disabled,
    ...(maxsize !== null && maxsize !== 'null' && maxsize ? { maxSize: maxsize } : {}),
    onDrop: (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) {
        return;
      }
      if (acceptedFiles.length > 0) {
        if (checkFormat(acceptedFiles[0])) {
          if (dimensions) {
            checkDimensions(acceptedFiles[0], dimensions, (isDimensionValid) => {
              if (isDimensionValid) {
                acceptedFiles = [acceptedFiles[0]];
                setimage(acceptedFiles[0]);
                setpreviewname([...previewname, acceptedFiles[0].name]);
                if (previewposition === 'inside') {
                  setpreviewname([...previewname, acceptedFiles[0].name]);
                } else {
                  setPreview(
                    acceptedFiles.map((upFile) =>
                      Object.assign(upFile, {
                        preview: URL.createObjectURL(upFile),
                      }),
                    ),
                  );
                }
                Setimagebool && Setimagebool(true);
              } else {
              }
            });
          } else {
            acceptedFiles = [acceptedFiles[0]];
            if (previewposition === 'inside') {
              setimage(acceptedFiles[0]);
              setpreviewname([...previewname, acceptedFiles[0].name]);
            } else {
              setPreview(
                acceptedFiles.map((upFile) =>
                  Object.assign(upFile, {
                    preview: URL.createObjectURL(upFile),
                  }),
                ),
              );
              setimage(acceptedFiles[0]);
            }
          }
        }
      } else {
        toast.error('only one file is allowed');
      }
    },
    onDropRejected: (fileRejections) => {
      fileRejections.forEach(({ errors }) => {
        errors.forEach((err) => {
          if (err.code === 'file-too-large') {
            setError('File size exceeds the allowed limit.');
            toast.error('File size exceeds the allowed limit.');
          } else if (err.code === 'file-invalid-type') {
            setError('Invalid file type.');

            toast.error('Invalid file type.');
          } else {
            setError(err.message);
            toast.error(err.message);
          }
        });
      });
    },
  });
  const handelClear = () => {
    if (disabled) return;
    setpreviewname([]);
    setimage(null);
    setPreview([]);
  };

  return (
    <React.Fragment>
      <div className={`justify-content-center ${classname}`}>
        {previewimage && previewposition === 'top' && (
          <div className="imagePreview imagePreview-custom d-flex justify-content-center mb-3">
            {preview.length > 0 ? (
              preview.map((upFile: any, index) => {
                // Specify the correct type 'File'
                return (
                  <div className="previewImage" key={index}>
                    <img src={upFile.preview} alt="preview" />
                  </div>
                );
              })
            ) : (
              <div className="previewImage">
                <img src={image || Previeew} alt="preview" />
              </div>
            )}
          </div>
        )}
        {image && previewname.length > 0 && previewimage && previewposition === 'inside' ? (
          <div
            className={`row justify-content-center ${classname === '' ? '' : 'dropzone-border'} `}
          >
            {previewname.length > 0 && (
              <div className="">
                {previewname.map((upFile: any, index) => {
                  return (
                    <div className={`${classname === '' ? 'inputDrops custom-drop' : 'boarder'} `}>
                      <div>
                        <div
                          className="d-flex justify-content-between align-items-center dropzon-innerpreview"
                          style={{ width: '85%' }}
                        >
                          <img src="" height={10} width={10} alt="excel" />
                          <span>{upFile}</span>
                          <h6 onClick={handelClear} className="m-0">
                            {' '}
                            X{' '}
                          </h6>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div
            className={`row justify-content-center hoverstyle ${
              classname === '' ? '' : 'dropzone-border'
            } `}
          >
            <div
              {...getRootProps()}
              className={`${classname === '' ? 'inputDrops custom-drop' : 'boarder'} ${disabled ? 'dropzone-disabled' : ''}`}
              style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}
            >
              <div>
                <input {...getInputProps()} />

                <div className="d-flex justify-content-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                  >
                    <path
                      d="M11 32C7.96667 32 5.375 30.95 3.225 28.85C1.075 26.75 0 24.1833 0 21.15C0 18.55 0.783333 16.2333 2.35 14.2C3.91667 12.1667 5.96667 10.8667 8.5 10.3C9.33333 7.23333 11 4.75 13.5 2.85C16 0.95 18.8333 0 22 0C25.9 0 29.2083 1.35833 31.925 4.075C34.6417 6.79167 36 10.1 36 14C38.3 14.2667 40.2083 15.2583 41.725 16.975C43.2417 18.6917 44 20.7 44 23C44 25.5 43.125 27.625 41.375 29.375C39.625 31.125 37.5 32 35 32H24V17.7L25.8 19.45C26.1667 19.8167 26.625 20 27.175 20C27.725 20 28.2 19.8 28.6 19.4C28.9667 19.0333 29.15 18.5667 29.15 18C29.15 17.4333 28.9667 16.9667 28.6 16.6L23.4 11.4C23 11 22.5333 10.8 22 10.8C21.4667 10.8 21 11 20.6 11.4L15.4 16.6C15.0333 16.9667 14.8417 17.425 14.825 17.975C14.8083 18.525 15 19 15.4 19.4C15.7667 19.7667 16.225 19.9583 16.775 19.975C17.325 19.9917 17.8 19.8167 18.2 19.45L20 17.7V32H11Z"
                      fill=""
                    />
                  </svg>
                </div>
                <div className="d-flex justify-content-center dropzone-font-size">
                  <p>
                    Drag and drop file here or <span className="color-underline">Choose file</span>
                  </p>
                </div>
                <div className="d-flex justify-content-center DropzoneText">
                  <p>
                    {DropZoneText.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
              <div>
                <span style={{ color: 'red', fontSize: 'small' }}>{isDragReject && Error}</span>
              </div>
            </div>
          </div>
        )}
        {previewimage && previewposition === 'original' && (
          <div className={Styles.CustomPreview}>
            {/* {previewname.map((upFile: any, index) => {
            return ( */}
            {(image || preview.length > 0) &&
              (preview.length > 0 ? (
                preview.map((upFile: any, index) => {
                  // Specify the correct type 'File'
                  return (
                    <div className={`${classname === '' && 'inputDrops custom-drop'} `}>
                      <div>
                        <div
                          className={` ${Styles.previewlook} d-flex justify-content-between align-items-center dropzon-innerpreview`}
                        >
                          <div>{SVG.document}</div>
                          {upFile.name && (
                            <span>
                              {upFile.name.split(' ').slice(0, 20).join(' ')}
                              {upFile.name.split(' ').length > 20 ? '...' : ''}
                            </span>
                          )}

                          <h6 onClick={handelClear} className="m-0" style={{ cursor: 'pointer' }}>
                            {' '}
                            X{' '}
                          </h6>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className={`${classname === '' && 'inputDrops custom-drop'} `}>
                  <div>
                    <div
                      className={` ${Styles.previewlook} d-flex justify-content-between align-items-center dropzon-innerpreview`}
                    >
                      <div>{SVG.document}</div>
                      <span>{'image.name'}</span>
                      <h6 onClick={handelClear} className="m-0">
                        {' '}
                        X{' '}
                      </h6>
                    </div>
                  </div>
                </div>
              ))}
            {/* );
          })} */}
          </div>
        )}
        {previewimage && previewposition === 'bottom' && (
          <div className="imagePreview imagePreview-custom d-flex justify-content-center mt-3">
            {preview.length > 0 ? (
              preview.map((upFile: any, index) => {
                // Specify the correct type 'File'
                return (
                  <div className="previewImage" key={index}>
                    <img src={upFile.preview} alt="preview" />
                  </div>
                );
              })
            ) : (
              <div className="previewImage">
                <img src={image || Previeew} alt="preview" />
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default DropZoneC;

// import React, { useCallback, useState, FC } from 'react';
// import { useDropzone } from 'react-dropzone';
// import Previeew from '../../assets/Preview.svg';
// import { toast } from 'react-toastify';

// interface DropZoneProps {
//   setimage: (file: File | null) => void;
//   DropZoneText?: string; // Corrected to lowercase 'string'
//   previewimage: Boolean;
//   classname?: String;
//   onClick?: () => void;
//   previewposition?: 'top' | 'bottom';
//   image: string;
// }

// const DropZoneC: FC<DropZoneProps> = ({
//   setimage,
//   DropZoneText,
//   previewimage = true,
//   classname = '',
//   onClick,
//   previewposition = 'top',
//   image,
// }) => {
//   const [preview, setPreview] = useState<File[]>([]);
//   const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
//     // accept: ['image/jpeg', 'image/png', 'image/gif'],
//     maxFiles: 1,
//     onDrop: (acceptedFiles: File[]) => {
//       if (acceptedFiles.length > 0) {
//         acceptedFiles = [acceptedFiles[0]];
//         setPreview(
//           acceptedFiles.map((upFile) =>
//             Object.assign(upFile, {
//               preview: URL.createObjectURL(upFile),
//             }),
//           ),
//         );
//         setimage(acceptedFiles[0]);
//       } else {
//         toast.error('only one file is allowed');
//       }
//     },
//   });

//   return (
//     <div className={`justify-content-center ${classname}`}>
//       {previewimage && previewposition === 'top' && (
//         <div className="imagePreview imagePreview-custom d-flex justify-content-center mb-3">
//           {preview.length > 0 ? (
//             preview.map((upFile: any, index) => {
//               // Specify the correct type 'File'
//               return (
//                 <div className="previewImage" key={index}>
//                   <img src={upFile.preview} alt="preview" />
//                 </div>
//               );
//             })
//           ) : (
//             <div className="previewImage">
//               <img src={image || Previeew} alt="preview" />
//             </div>
//           )}
//         </div>
//       )}
//       <div className={`row justify-content-center ${classname === '' ? '' : 'dropzone-border'} `}>
//         <div
//           {...getRootProps()}
//           className={`${classname === '' ? 'inputDrops custom-drop' : 'boarder'} `}
//         >
//           <input {...getInputProps()} />
//           <div>
//             <div className="d-flex justify-content-center">
//               <img src={'/manage/images/SVG/backup.svg'} alt="..." className="upload_icon" />
//             </div>
//             <div className="d-flex justify-content-center">
//               <p>
//                 Drag and drop file here or <span className="color-underline">Choose file</span>
//               </p>
//             </div>
//             <div className="d-flex justify-content-center DropzoneText">
//               <p>{DropZoneText} </p>
//             </div>
//           </div>
//           {isDragReject && 'File type not accepted, sorry!'}
//         </div>
//       </div>
//       {previewimage && previewposition === 'bottom' && (
//         <div className="imagePreview imagePreview-custom d-flex justify-content-center mt-3">
//           {preview.length > 0 ? (
//             preview.map((upFile: any, index) => {
//               // Specify the correct type 'File'
//               return (
//                 <div className="previewImage" key={index}>
//                   <img src={upFile.preview} alt="preview" />
//                 </div>
//               );
//             })
//           ) : (
//             <div className="previewImage">
//               <img src={image || Previeew} alt="preview" />
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DropZoneC;
